import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// Initialize Chart.js before any other imports that might use it
import './chartSetup';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icons.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';

// Import Main styles for this application
import './assets/scss/style.scss';
// Temp fix for reactstrap
import './assets/scss/core/_dropdown-menu-right.scss';

import './assets/font/lcd.css';
import './assets/TabTheme.css';
import './assets/pagination.css';
// Containers
import Full from './containers/Full/Full';
import Login from './views/Login/Login';
import ForgotPassw from './views/ForgotPassw/forgotPassw';
import SetPassw from './views/SetPassword/setPassw';
import RegistrationForm from './views/RegistrationForm/RegistrationForm';

import PluginPrivateRoute from './views/PrivateRoute/PluginPrivateRoute';
import DeviceControlPlugin from './plugin/DeviceControl/DeviceControl';

import API from './services/api/api';

import { Provider, connect } from 'react-redux';
import store from './store';
import { deleteUser } from './store/user';
import { ToastContainer } from 'react-toastify';

//React DatePicker
import 'react-datepicker/dist/react-datepicker.css';

// Sentry
import * as Sentry from '@sentry/react';

if (module.hot) {
	module.hot.accept();
}

API.setUnauthorizedCallback((error) => {
	store.dispatch(deleteUser());
});

const PrivateRouteComponent = ({ children, user }) => {
	return user !== null ? (
		children
	) : (
		<Navigate to="/login" replace relative="false" />
	);
};

const mapStateToProps = (state) => ({
	user: state.user
});

const PrivateRoute = connect(mapStateToProps)(PrivateRouteComponent);

//Ez az alerteknek kell
const containerStyle = {
	zIndex: 1999
};

// Sentry Integration
if (
	process.env.REACT_APP_NODE_ENV &&
	process.env.REACT_APP_NODE_ENV.toLocaleUpperCase() == 'PRODUCTION'
) {
	Sentry.init({
		dsn: 'https://23e5866b4a3b40cc872168d4372c8959@o351135.ingest.sentry.io/6055806',
		integrations: [],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0
	});
}

//<Route path="/registration/:cmID" name="Reg" element={<Regist />} />
const container = document.getElementById('root');
const root = createRoot(container);


root.render(
	<>
		<ToastContainer
			position="top-right"
			autoClose={5000}
			style={containerStyle}
		/>
		<Provider store={store}>
			<HashRouter>
				<Routes>
					<Route path="/login" element={<Login />} />

					<Route path="/forgotPassw" element={<ForgotPassw />} />
					<Route path="/setPassw/:key" element={<SetPassw />} />
					<Route path="/registration/:key" element={<RegistrationForm />} />

					<Route
						path="/plugin/deviceControl"
						element={
							<PluginPrivateRoute>
								<DeviceControlPlugin />
							</PluginPrivateRoute>
						}
					/>

					<Route path="/*" element={<Full />} />
				</Routes>
			</HashRouter>
		</Provider>
	</>
);

/*

				
*/
